import React from 'react';
import IdealForm from './iDealForm';
import { saveState } from './localStorage';
import Cookies from 'js-cookie'
import axios from 'axios';
import { getToken } from '~/redux/user/tokens';
class StripeIDeal extends React.Component {

  constructor(props) {
    super(props)
    let domain = window.location.hostname
    let redirectURL = ""
    if(domain === 'localhost') {
      redirectURL = "http://localhost:3000"
    } else {
      redirectURL = 'https://'+domain
    }
    this.state = {
      redirect: `${`${window.settings.apiBaseUrl}/payments/stripe/redirect`}?to=${encodeURI(redirectURL+'?popup=thankYou')}`,
      agreementConfirm : false,
      currentStatus : false
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
  }

  handleResult = (sourceResponse) => {
    var ref = this;
    getToken()
    .then(token => axios({
      url: `${window.settings.apiBaseUrl}/payments/stripe/subscription/ideal`, 
      method: "POST",
      headers: {
        'Authorization': token,
        'Content-Type': 'application/json',
        'x-api-key': window.settings.baseAPIKey
      },
      data: { planId: this.props.plan.id, source: sourceResponse, redirect: this.state.redirect, appliedOffers: this.props.offerCode ? [{offerId: this.props.offerCode.id, offerCode: this.props.offerCode.code, offerName: this.props.offerCode.name}] : [] }
    }))
    .then(res => {
      Cookies.set('isiDealPayment',true)
      saveState('stripeIdeal', {
        source: sourceResponse.source.id,
        clientSecret: sourceResponse.source.client_secret,
        planId: ref.props.plan.id,
        planName: ref.props.plan.name,
        site: window.settings.internalName
      });
      this.setState({currentStatus : false})
      window.location.href = res.data.redirectUrl;
    })
    .catch(error => {
      Cookies.remove('isiDealPayment')
      return error.response;
    })
  };

  handleChange(event){
    this.setState({agreementConfirm : event.currentTarget.checked || false})
  }
  
  generateId() {
    const s4 = _ => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
  }

  render() {
    let amount = (this.props.amount) || (this.props.plan ? this.props.plan.planDetails[0].recurringPaymentAmount : 0);
    const stripeTestKey = (window.settings.paymentProviders && window.settings.paymentProviders.stripe && window.settings.paymentProviders.stripe.apiKey) || null;
    return (<div>
      <IdealForm
        stripePublicKey={stripeTestKey}
        handleResult={this.handleResult}
        amount={parseInt(Number(amount).toFixed(2) * 100)}
        returnUrl={this.state.redirect}
        agreementStatus={this.state.agreementConfirm}
        statementDescriptor={this.generateId()} 
        currentStatus={this.state.currentStatus}
        fields={this.props.fields}
      />
      <br></br>
      <div className="idealAgreementText">
        <input type="checkbox" className="agreementConfirm" onClick={this.handleChange} />
        <span>{this.props.fields.iDealAgreementText || "By providing your IBAN and confirming this payment, you are authorizing Rocketship Inc and Stripe, our payment service provider, to send instructions to your bank to debit your account and your bank to debit your account in accordance with those instructions. You are entitled to a refund from your bank under the terms and conditions of your agreement with your bank. A refund must be claimed within 8 weeks starting from the date on which your account was debited."}</span>
        </div>
    </div>
    );
  }
}

export default StripeIDeal;